import { ExtendableError } from "@putdotio/utilities";

export class BFFError extends ExtendableError {
  constructor(message: string) {
    super(`BFFError: ${message}`);
  }
}
